/* eslint-disable */
import React from 'react';

const disabledColor = '#9FA4AD';
const activeColor = 'white';

export const MSDIcon = ({ className, disabled }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.2133 5.7286C8.4467 5.7286 7.82267 5.10457 7.82267 4.33723C7.82267 3.56988 8.4467 2.94585 9.2133 2.94585C9.98065 2.94585 10.6047 3.56988 10.6047 4.33723C10.6047 5.10457 9.98065 5.7286 9.2133 5.7286ZM9.21523 1.25C7.51333 1.25 6.12793 2.6354 6.12793 4.3373C6.12793 5.92499 8.64196 8.98318 8.92859 9.32654C8.99951 9.41164 9.10401 9.4609 9.21523 9.4609C9.3257 9.4609 9.43095 9.41164 9.50186 9.32654C9.7885 8.98318 12.3033 5.92499 12.3033 4.3373C12.3033 2.6354 10.9179 1.25 9.21523 1.25Z"
      fill={disabled ? disabledColor : activeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9377 10.5809C15.2271 10.5809 14.6486 10.0024 14.6486 9.29101C14.6486 8.58039 15.2271 8.00264 15.9377 8.00264C16.6491 8.00264 17.2268 8.58039 17.2268 9.29101C17.2268 10.0024 16.6491 10.5809 15.9377 10.5809ZM15.9369 6.47554C14.3843 6.47554 13.1206 7.73853 13.1206 9.29114C13.1206 10.7348 15.3913 13.4959 15.6503 13.8056C15.7212 13.8907 15.8257 13.94 15.9369 13.94C16.0474 13.94 16.1519 13.8907 16.2236 13.8064C16.4819 13.4959 18.7533 10.7348 18.7533 9.29114C18.7533 7.73853 17.4896 6.47554 15.9369 6.47554Z"
      fill={disabled ? disabledColor : activeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.7352 13.7758C3.7581 13.7758 2.96388 12.9816 2.96388 12.0038C2.96388 11.0274 3.7581 10.2332 4.7352 10.2332C5.7123 10.2332 6.50652 11.0274 6.50652 12.0038C6.50652 12.9816 5.7123 13.7758 4.7352 13.7758ZM7.45492 9.86455C6.82716 9.12333 5.86126 8.71428 4.73487 8.71428C3.60102 8.71428 2.62765 9.13303 1.99467 9.89217C1.36765 10.6446 1.11983 11.6866 1.3154 12.7518C1.49529 13.7401 2.22532 14.8329 2.93071 15.8906C3.63386 16.9453 4.36165 18.0344 4.36165 18.7913C4.36165 18.9981 4.52885 19.1645 4.73487 19.1645C4.94089 19.1645 5.10809 18.9981 5.10809 18.7913C5.10809 18.006 5.88664 16.8229 6.63905 15.6779C7.34743 14.6 8.01624 13.5819 8.15658 12.7473C8.34244 11.6426 8.09313 10.6185 7.45492 9.86455Z"
      fill={disabled ? disabledColor : activeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5626 13.0217C13.4917 13.0217 13.42 13.0016 13.3558 12.9583L9.69373 10.5174C9.52205 10.4039 9.47577 10.1725 9.58998 10.0009C9.70418 9.82918 9.93558 9.7829 10.108 9.89711L13.7701 12.3372C13.9418 12.4522 13.988 12.6843 13.8731 12.8553C13.8014 12.9635 13.6835 13.0217 13.5626 13.0217Z"
      fill={disabled ? disabledColor : activeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.64319 18.2763C6.50286 18.2763 6.36776 18.1964 6.30431 18.0605C6.21772 17.8739 6.29834 17.6522 6.48495 17.5649L13.9098 14.0999C14.0965 14.0126 14.3189 14.0932 14.4062 14.2798C14.4936 14.4664 14.4129 14.6888 14.2256 14.7762L6.80069 18.2412C6.74994 18.2651 6.69619 18.2763 6.64319 18.2763Z"
      fill={disabled ? disabledColor : activeColor}
    />
  </svg>
);

export const SingleBookingIcon = ({ className, disabled }) => (
  <svg
    className={className}
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.13321 8.14563C4.6961 8.14563 3.52705 7.03354 3.52705 5.66646C3.52705 4.29938 4.6961 3.18729 6.13321 3.18729C7.57032 3.18729 8.73937 4.29938 8.73937 5.66646C8.73937 7.03354 7.57032 8.14563 6.13321 8.14563ZM6.1332 0C2.8487 0 0.17627 2.5415 0.17627 5.66667C0.17627 8.67283 5.59187 16.5091 5.8227 16.8406C5.8912 16.9398 6.00811 17 6.1332 17C6.2583 17 6.37446 16.9398 6.44371 16.8406C6.67454 16.5091 12.0901 8.67283 12.0901 5.66667C12.0901 2.5415 9.41771 0 6.1332 0Z"
      fill={disabled ? disabledColor : activeColor}
    />
  </svg>
);

export default {};
